const en_master_goodsPrice = {
    "": "change price",
}

export default en_master_goodsPrice;